import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "icon-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#icon-colors" }),
  /*#__PURE__*/_createTextVNode(" Icon Colors ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" The inline icons can be colored using "),
  /*#__PURE__*/_createVNode("code", null, ".text-{color}"),
  /*#__PURE__*/_createTextVNode(" class that defined with "),
  /*#__PURE__*/_createVNode("code", null, "$theme-text-colors"),
  /*#__PURE__*/_createTextVNode(" variable in "),
  /*#__PURE__*/_createVNode("code", null, "sass/_variables.scss"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border d-flex flex-wrap p-10" }
const _hoisted_6 = { class: "fw-bold py-2" }
const _hoisted_7 = { class: "py-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<i class="bi bi-droplet-half text-white"></i>
        <i class="bi bi-droplet-half text-primary"></i>
        <i class="bi bi-droplet-half text-secondary"></i>
        <i class="bi bi-droplet-half text-light"></i>
        <i class="bi bi-droplet-half text-success"></i>
        <i class="bi bi-droplet-half text-info"></i>
        <i class="bi bi-droplet-half text-warning"></i>
        <i class="bi bi-droplet-half text-danger"></i>
        <i class="bi bi-droplet-half text-dark"></i>
        <i class="bi bi-droplet-half text-muted"></i>
        <i class="bi bi-droplet-half text-gray-100"></i>
        <i class="bi bi-droplet-half text-gray-200"></i>
        <i class="bi bi-droplet-half text-gray-300"></i>
        <i class="bi bi-droplet-half text-gray-400"></i>
        <i class="bi bi-droplet-half text-gray-500"></i>
        <i class="bi bi-droplet-half text-gray-600"></i>
        <i class="bi bi-droplet-half text-gray-700"></i>
        <i class="bi bi-droplet-half text-gray-800"></i>
        <i class="bi bi-droplet-half text-gray-900"></i>`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "d-flex flex-column flex-center w-150px me-10 mb-5"
          }, [
            _createVNode("i", {
              class: [[`text-${item}`, item === 'white' && `bg-dark`], "bi bi-droplet-half fs-2x"]
            }, null, 2),
            _createVNode("div", _hoisted_6, _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}